import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import iconPencil from "../img/icons/icon-pencil.svg";
import iconTrash from "../img/icons/icon-trash.svg";

export default function ProposalJoin(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    //Join
    let refCompany = React.useRef();
    let refAddress = React.useRef();
    let refYear = React.useRef();
    let refGuideline = React.useRef();
    let refIncash = React.useRef();
    let refInkind = React.useRef();
    let refOther = React.useRef();
    let refTotal = React.useRef();

    let [showFormJoin, setShowFormJoin] = React.useState(false);
    let [joinList, setJoinList] = React.useState(null);
    let [joinEditId, setJoinEditId] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const proRes = await getJoinList();
                setJoinList(proRes);
            } catch (e) {
                //
            }
        })();
    }, []);

    const onJoinAdd = () => {
        refCompany.current.value = '';
        refAddress.current.value = '';
        refYear.current.value = '';
        refGuideline.current.value = '';
        refIncash.current.value = '';
        refInkind.current.value = '';
        refOther.current.value = '';
        refTotal.current.value = '';
        setShowFormJoin(true);
        setJoinEditId(null);
    };
    const onJoinCancel = () => {
        setShowFormJoin(false);
    };
    const onJoinEdit = async (id) => {
        const result = await getJoinListView(id);
        if(result) {
            setJoinEditId(id);
            setShowFormJoin(true);
            refCompany.current.value = result.company;
            refAddress.current.value = result.address;
            refYear.current.value = result.year;
            refGuideline.current.value = result.guideline;
            refIncash.current.value = result.incash;
            refInkind.current.value = result.inkind;
            refOther.current.value = result.other;
            refTotal.current.value = result.total;
        }
    };
    const onJoinSubmit = () => {
        let company = refCompany.current.value;
        let address = refAddress.current.value;
        let year = refYear.current.value;
        let guideline = refGuideline.current.value;
        let incash = refIncash.current.value;
        let inkind = refInkind.current.value;
        let other = refOther.current.value;
        let total = refTotal.current.value;

        if(company === '') {
            toast.error(prop.lang === 'en' ? 'Please specify company':'กรุณาระบุ ชื่อหน่วยงาน/บริษัท');
            refCompany.current.focus();
        }
        else if(address === '') {
            toast.error(prop.lang === 'en' ? 'Please specify address':'กรุณาระบุ ที่อยู่หน่วยงาน/บริษัท');
            refAddress.current.focus();
        }
        else if(year === '') {
            toast.error(prop.lang === 'en' ? 'Please specify year':'กรุณาระบุ ปีที่');
            refYear.current.focus();
        }
        else if(guideline === '') {
            toast.error(prop.lang === 'en' ? 'Please specify guideline':'กรุณาระบุ แนวทางร่วมดำเนินการ');
            refGuideline.current.focus();
        }
        else if(incash === '') {
            toast.error(prop.lang === 'en' ? 'Please specify in-cash':'กรุณาระบุ การร่วมลงทุนในรูปแบบตัวเงิน (in-cash) (บาท)');
            refIncash.current.focus();
        }
        else if(inkind === '') {
            toast.error(prop.lang === 'en' ? 'Please specify in-kind':'กรุณาระบุ การร่วมลงทุนในรูปแบบอื่น (in-kind) (บาท)');
            refInkind.current.focus();
        }
        else if(other === '') {
            toast.error(prop.lang === 'en' ? 'Please specify other':'กรุณาระบุ รายละเอียดการร่วมลงทุนในรูปแบบอื่น (in-kind)');
            refOther.current.focus();
        }
        else if(total === '') {
            toast.error(prop.lang === 'en' ? 'Please specify total':'กรุณาระบุ รวม');
            refTotal.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                id: joinEditId,
                                proposalId: proposalId,
                                company: company,
                                address: address,
                                year: year,
                                guideline: guideline,
                                incash: incash,
                                inkind: inkind,
                                other: other,
                                total: total,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createJoin(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refCompany.current.value = '';
                                    refAddress.current.value = '';
                                    refYear.current.value = '';
                                    refGuideline.current.value = '';
                                    refIncash.current.value = '';
                                    refInkind.current.value = '';
                                    refOther.current.value = '';
                                    refTotal.current.value = '';

                                    toast.success(prop.lang === 'en' ? 'Add Joint Implementing Agencies successfully.':'บันทึกส่วนข้อมูลหน่วยงานร่วมดำเนินการ เรียบร้อย');
                                    setShowFormJoin(false);
                                    const teamRes = await getJoinList();
                                    setJoinList(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };
    const onJoinDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteJoin(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowFormJoin(false);
                                const teamRes = await getJoinList();
                                setJoinList(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createJoin(param) {
        const response = await fetch(Config.apiUrl +'/proposalJoin/' + (joinEditId ? 'updateJoin':'createJoin'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getJoinList() {
        const response = await fetch(Config.apiUrl +'/proposalJoin/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getJoinListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalJoin/viewJoin', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteJoin(id) {
        const response = await fetch(Config.apiUrl +'/proposalJoin/deleteJoin', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="row g-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between gap-3">
                        <h6 className="pt-1"></h6>
                        {
                            readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onJoinAdd}>
                                {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายการ'}
                            </button>
                        }
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                            <thead>
                            <tr>
                                <th className="text-center">
                                    {prop.lang === 'en' ? 'No':<>ลำดับที่</>}
                                </th>
                                <th>
                                    {prop.lang === 'en' ? 'Name':<>ชื่อหน่วยงาน<br />/บริษัท</>}
                                </th>
                                <th>
                                    {prop.lang === 'en' ? 'Address':<>ที่อยู่</>}
                                </th>
                                <th className="text-center">{prop.lang === 'en' ? 'Year No':'ปีที่'}</th>
                                <th>
                                    {prop.lang === 'en' ? 'Action Guidelines':<>แนวทาง<br />ร่วมดำเนินการ</>}
                                </th>
                                <th className="text-end">
                                    {prop.lang === 'en' ? 'in-cash':<>การร่วมลงทุน<br />ในรูปแบบตัวเงิน<br />(in-cash) (บาท)</>}
                                </th>
                                <th className="text-end">
                                    {prop.lang === 'en' ? 'in-kind':<>การร่วมลงทุน<br />ในรูปแบบอื่น<br />(in-kind) (บาท)</>}
                                </th>
                                <th className="text-end">
                                    {prop.lang === 'en' ? 'other':<>รายละเอียดการ่วม<br />ลงทุนในรูปแบบอื่น<br />(in-kind)</>}
                                </th>
                                <th className="text-end">
                                    {prop.lang === 'en' ? 'Total':<>รวม</>}
                                </th>

                                {
                                    readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                joinList !== null && joinList.count > 0 ?
                                    joinList.rows.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{(index+1)}</td>
                                                <td>{row.company}</td>
                                                <td>{row.address}</td>
                                                <td className="text-center">{row.year}</td>
                                                <td>{row.guideline}</td>
                                                <td className="text-end">{Utils.numberWithCommas(row.incash ?? '0')}</td>
                                                <td className="text-end">{Utils.numberWithCommas(row.inkind ?? '0')}</td>
                                                <td className="text-end">{Utils.numberWithCommas(row.other ?? '0')}</td>
                                                <td className="text-end">{Utils.numberWithCommas(row.total ?? '0')}</td>
                                                {
                                                    readOnly ? '' : <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className="btn btn-trans" onClick={e => onJoinEdit(row.id)}>
                                                                <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                            </button>
                                                            <button className="btn btn-trans" onClick={e => onJoinDelete(row.id)}>
                                                                <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={5}>-</td></tr>
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={"row g-3 mt-2" + (showFormJoin ? '':' d-none')}>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Name':'ชื่อหน่วยงาน/บริษัท'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refCompany} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Address':'ที่อยู่'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refAddress} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Year':'ปีที่'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refYear} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-xl-9 col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Action Guidelines':'แนวทางร่วมดำเนินการ'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refGuideline} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'in-cash':'การร่วมลงทุนในรูปแบบตัวเงิน (in-cash) (บาท)'} <span className="star">*</span></h6>
                                <input type="number" className="form-control" ref={refIncash} maxLength={11} min={1} onKeyUp={e => {
                                    refTotal.current.value = parseInt(e.target.value) + (refInkind.current.value ? parseInt(refInkind.current.value) : 0);
                                }} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'in-kind':'การร่วมลงทุนในรูปแบบอื่น (in-kind) (บาท)'} <span className="star">*</span></h6>
                                <input type="number" className="form-control" ref={refInkind} maxLength={11} min={1} onKeyUp={e => {
                                    refTotal.current.value = parseInt(e.target.value) + (refIncash.current.value ? parseInt(refIncash.current.value) : 0);
                                }} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'in-cash other':'รายละเอียดการร่วมลงทุนในรูปแบบอื่น (in-kind)'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refOther} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Total':'รวม'} <span className="star">*</span></h6>
                                <input type="number" className="form-control" ref={refTotal} maxLength={11} min={1} />
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="buttons gap-15 py-0">
                                <button className="btn btn-xs btn-green" type="button" onClick={onJoinSubmit}>
                                    {prop.lang === 'en' ? 'Save':'บันทึก'}
                                </button>
                                <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onJoinCancel}>
                                    {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 